// extracted by mini-css-extract-plugin
export default {"tagArea":"TagWrap_tagArea__jA5ZR"};